/* ONEGENZ V59: safeguard against outbound supplier links inside product descriptions. */
(function(){
 function clean(){
  document.querySelectorAll('.og34-description-body, .og-detail-content .rte').forEach(function(root){
   root.querySelectorAll('a[href]').forEach(function(a){
    try { var u=new URL(a.getAttribute('href'),window.location.href); if(u.protocol==='http:'||u.protocol==='https:') {if(u.hostname!==window.location.hostname && !u.hostname.endsWith('.onegenz.com')) {a.replaceWith(document.createTextNode(a.textContent||''));}} }catch(e){}
   });
   root.querySelectorAll('p,li').forEach(function(el){
    var t=(el.textContent||'').trim();
    if(/^(source listing\s*:|supplier authorization and availability require confirmation|view original listing)/i.test(t)){el.remove();}
   });
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',clean);else clean();
})();
